import AmexGDAFooter from './AmexGDAFooter';

export default AmexGDAFooter;
